import React from 'react'
import styled from 'styled-components'
import rocket from '../assets/images/rocket.gif'

const StyledDiv = styled.div`
  z-index: 99;
  position: absolute;
  height: 100%;
  width: 100%;
  background-image: url('${rocket}');
  background-repeat: no-repeat;
  background-position: center;
  background-color: white;
`

const Loading = ({ loading = false, style }) => {
  return (
    <StyledDiv
      role="progressbar"
      aria-label="Carregando"
      aria-valuetext="Carregando"
      aria-busy={loading}
      style={{ display: loading ? 'block' : 'none', ...style }}
    />
  )
}

export default Loading
